.modalWrapper {
  margin: auto auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border: none;
  outline: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: auto;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.body {
  overflow: hidden;
}

.body :global(#root) {
  filter: blur(4px);
}

.modalBackground {
  background-color: var(--ds-poker-green-darkest);
  box-shadow: 0px 0px 30px 26px rgba(0, 0, 0, 0.3);

  border-radius: 24px;
  padding: 40px 32px;

  /* at least some room for the top/bottom padding, plus a little extra */
  height: min(400px, calc(100vh - 40px * 2 - 40px));

  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;

  max-width: 500px;
}

.cardImageAndButtonWrapper {
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  position: relative;

  & .flipIcon {
    position: relative;
    bottom: -10px;
    cursor: pointer;
    display: flex;
    font-size: 15px;
    /* bright color on top of felt */
    color: var(--ds-pearl-grey-darkest);
  }

  & .flipIcon:hover {
    color: var(--ds-white);
  }
}

.cardImage {
  max-height: 100%;
}

.cardDescriptionWrapper {
  margin-left: 20px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  height: 100%;
}

.cardTitle,
.cardDescriptionText {
  text-align: center;
}

.cardDescriptionText {
  margin-top: 8px;
}

.infoGrid {
  margin-top: 40px;

  display: grid;
  grid-template-columns: auto auto;
  width: 200px;

  & .infoGridItemData {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
  }

  & > :nth-child(4n-2),
  & > :nth-child(4n-3) {
    background-color: var(--ds-poker-green-darker);
  }
}

.flexSpacer {
  flex-grow: 1;
}

.dismissButton {
  justify-self: flex-end;
}

.starIcon {
  color: #ffdf00;
}
